(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace/create-game/assets/javascripts/product-selection-bottom-sheet.js') >= 0) return;  svs.modules.push('/components/marketplace/create-game/assets/javascripts/product-selection-bottom-sheet.js');
'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useContext = _React.useContext,
  useCallback = _React.useCallback,
  useEffect = _React.useEffect,
  useState = _React.useState,
  useRef = _React.useRef;
const _ReactRouterDOM = ReactRouterDOM,
  useHistory = _ReactRouterDOM.useHistory,
  useParams = _ReactRouterDOM.useParams;
const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector;
const hooks = svs.components.marketplace.createGame.hooks;
const getProductItems = svs.components.marketplaceData.createGame.helpers.getProductItems;
const selectTeam = svs.components.marketplaceData.selectors.teams.selectTeam;
const _svs$components$marke = svs.components.marketplace.marketplaceBrand,
  MarketplaceBrand = _svs$components$marke.MarketplaceBrand,
  MarketplaceBrandContext = _svs$components$marke.MarketplaceBrandContext;
const helpers = svs.components.marketplace.helpers;
const resolveProductId = svs.utils.products.resolveProductId;
const _svs$ui = svs.ui,
  ReactIcon = _svs$ui.ReactIcon,
  Button = _svs$ui.ReactButton;
const JackPotAndFunds = svs.components.lbUi.jackpotAndFunds.JackPotAndFunds.JackPotAndFunds;
const ProductSelectionBottomSheet = _ref => {
  let onClose = _ref.onClose;
  const history = useHistory();
  const _useParams = useParams(),
    groupId = _useParams.groupId;
  const _useContext = useContext(MarketplaceBrandContext),
    getBrandedDisplayName = _useContext.getBrandedDisplayName;
  const _useSelector = useSelector(state => state.CreateGame || {}),
    availableProducts = _useSelector.availableProducts;
  const _hooks$useDraws = hooks.useDraws({
      groupId
    }),
    draws = _hooks$useDraws.draws;
  const _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    productItems = _useState2[0],
    setProductItems = _useState2[1];
  const prevProductItemsRef = useRef();
  const _useSelector2 = useSelector(state => selectTeam(state, {
      id: groupId
    })),
    teamId = _useSelector2.id,
    teamName = _useSelector2.name;
  const onProductClick = useCallback((productName, isDisabled) => {
    if (!isDisabled) {
      history.push({
        pathname: helpers.getTeamUrl(teamId, teamName, 'skapa-spel'),
        search: "?productName=".concat(productName),
        state: {
          internalLink: true
        }
      });
    }
  }, [history, teamId, teamName]);
  useEffect(() => {
    const fetchProductItems = async () => {
      const currentProductItems = await getProductItems({
        allProductNames: availableProducts,
        drawsByProduct: draws
      });
      if (!prevProductItemsRef.current || JSON.stringify(prevProductItemsRef.current) !== JSON.stringify(currentProductItems)) {
        setProductItems(currentProductItems);
      }
      prevProductItemsRef.current = currentProductItems;
    };
    fetchProductItems();
  }, [availableProducts, draws]);
  if (!productItems) {
    return null;
  }
  return React.createElement(svs.ui.ReactBottomSheet.BottomSheet, {
    behavior: "standard",
    className: "bottom-sheet-products qa-bottom-sheet-products",
    customer: "sport",
    isFixed: true,
    transparent: false
  }, React.createElement("div", {
    className: "bottom-sheet-products-header"
  }, React.createElement("div", {
    className: "title f-600 f-medium"
  }, "V\xE4lj spelomg\xE5ng"), React.createElement(Button, {
    className: "qa-back-button back-button icon-button",
    onClick: () => onClose(),
    type: "button"
  }, React.createElement(ReactIcon, {
    icon: "close",
    size: "300"
  }))), React.createElement("div", {
    className: "bottom-sheet-product-items-holder"
  }, productItems.map((productItem, index) => {
    const productName = productItem.item,
      disabledReason = productItem.disabledReason,
      isDisabled = productItem.isDisabled,
      _productItem$jackpots = productItem.jackpots,
      jackpots = _productItem$jackpots === void 0 ? [] : _productItem$jackpots,
      _productItem$funds = productItem.funds,
      funds = _productItem$funds === void 0 ? [] : _productItem$funds;
    const productId = resolveProductId(productName);
    const hasJackpotOrFunds = jackpots.length > 0 || funds.length > 0;
    const key = "".concat(productId, "_").concat(index);
    return React.createElement("div", {
      className: "bottom-sheet-product-item ".concat(isDisabled ? 'disabled' : ''),
      key: key,
      onClick: () => onProductClick(productName, isDisabled)
    }, React.createElement(MarketplaceBrand, {
      productId: productId,
      size: 100,
      square: true
    }), React.createElement("div", {
      className: "f-uppercase product-item-name f-600 f-medium"
    }, getBrandedDisplayName(productId)), Boolean(isDisabled) && React.createElement("div", {
      className: "product-item-disabled-reason"
    }, disabledReason), hasJackpotOrFunds && React.createElement("div", null, React.createElement(JackPotAndFunds, {
      funds: funds,
      jackpots: jackpots,
      productId: productId
    })));
  })));
};
setGlobal('svs.components.marketplace.createGame.ProductSelectionBottomSheet', ProductSelectionBottomSheet);

 })(window);